import { fork } from '@redux-saga/core/effects'
import { paymentSharedSaga } from './shared'
import { fundSaga } from './fund'

export function* paymentSaga() {
  yield fork(paymentSharedSaga)
  yield fork(fundSaga)
}
